import { Injectable, inject } from '@angular/core';

import { DynamicLayoutService, OnFeatureInit, SlotName } from '@frontend/vanilla/core';

import { TopMessagesComponent } from './top-messages.component';

@Injectable()
export class TopMessagesBootstrapService implements OnFeatureInit {
    private dynamicLayoutService = inject(DynamicLayoutService);

    onFeatureInit() {
        this.dynamicLayoutService.addFirstComponent(SlotName.Messages, TopMessagesComponent, null);
    }
}
